<template>
    <v-layout class=" wrap pb-5">
        <v-flex md8>
            <template v-if="paginated.length > 0">
                <liveNewsBlock v-for="(item, i) in paginated" :key="i" :content="item" />
            </template>
            <div v-else>{{$t("По запросу ничего не найдено")}}</div>
            <v-layout v-if="live_news.length>10" justify-space-between align-center
                      wrap
                      class="mt-5"
            >
                <v-flex md5 sm7 xs12
                        mb-4
                >
                    <v-pagination
                        v-model="page"
                        :length="Math.ceil(live_news.length / selected_number)"
                        :total-visible="$vuetify.breakpoint.xs ? 4 : 5"
                        prev-icon="arrow_back_ios"
                        next-icon="arrow_forward_ios"
                    />
                </v-flex>
                <v-flex md4 sm5 xs12
                        mb-4
                >
                    <v-select
                        :items="$vuetify.breakpoint.mdAndUp ? [$t('Показывать по 10'),$t('Показывать по 25'),$t('Показывать по 50'),$t('Показывать по 100')]
                        : [$t('Показывать по 10'),$t('Показывать по 25'),$t('Показывать по 50')]"
                        solo
                        append-icon=""
                        :label="$t('Показывать по 10')"
                        class="input"
                        @change="show_number($event, 10)"
                    >
                      <template #append>
                        <v-icon aria-hidden="true" translate="no">
                          expand_more
                        </v-icon>
                      </template>
                    </v-select>
                </v-flex>
                <v-flex xs12>
                    <router-link to="{name:'live_news'}">
                        <buttonBdWhite>{{$t("Вся лента")}}</buttonBdWhite>
                    </router-link>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
import liveNewsBlock from '@/components/view_blocks/Live_news/Live_news_block';
import buttonBdWhite from '@/components/ui/buttons/button_bd_white';
import {mapGetters, mapMutations, mapActions} from 'vuex';
export default {
  components: {
    liveNewsBlock,
    buttonBdWhite,
  },
  computed: {
    ...mapGetters('activity/live_news', [
      'live_news',
      'paginated',
      'selected_number',
      'selected_page',
    ]),
    page: {
      get() {
        return this.selected_page;
      },
      set($event) {
        return this.SET_SELECTED_PAGE($event);
      },
    },
  },
  // mounted() {
  //   this.get_live_news();
  // },
  methods: {
    ...mapActions('activity/live_news', [
      'show_number',
    ]),
    ...mapMutations('activity/live_news', [
      'SET_SELECTED_PAGE',
      'SHOW_NUMBER',
      'CLEAR_PAGES',
      'SEARCH_STRING',
    ]),
  },

};
</script>
